/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconNavigationCode = createReactComponent("navigation-code", "IconNavigationCode", [
  [
    "path",
    {
      d: "M16.653 13.086l-4.653 -10.086l-7.97 17.275c-.07 .2 -.017 .424 .135 .572c.15 .148 .374 .193 .57 .116l6.246 -2.117",
      key: "svg-0"
    }
  ],
  ["path", { d: "M20 21l2 -2l-2 -2", key: "svg-1" }],
  ["path", { d: "M17 17l-2 2l2 2", key: "svg-2" }]
]);

export { IconNavigationCode as default };
//# sourceMappingURL=IconNavigationCode.js.map
